module.exports = "<span>\n  {{data}}\n</span>\n";